<form class="flexer">
  <div class="form-sub-title">Formaat</div>

  <mat-radio-group
    *ngIf="index === 0"
    aria-label="Select an option"
    class="d-flex"
  >
    <div
      [className]="position === 'square' ? 'grey' : 'white'"
      class="first spaced centered"
    >
      <div class="size-choice bordere subtitle-white">Vierkant</div>

      <mat-radio-button
        class="top-spaced"
        [value]="'square'"
        [checked]="position === 'square'"
        [disabled]="disabled"
        (change)="positionChange($event.value)"
      >
        Vierkant
      </mat-radio-button>
    </div>

    <div
      [className]="position === 'horizontal' ? 'grey' : 'white'"
      class="spaced centered"
    >
      <div class="bordered">
        <div class="white-space"></div>

        <div class="rectangled-horizontal subtitle-white">Rechthoekig</div>
      </div>

      <mat-radio-button
        class="top-spaced"
        [value]="'horizontal'"
        [checked]="position === 'horizontal'"
        [disabled]="disabled"
        (change)="positionChange($event.value)"
      >
        Liggend
      </mat-radio-button>
    </div>

    <div
      [className]="position === 'vertical' ? 'grey' : 'white'"
      class="spaced centered"
    >
      <div class="bordered d-flex">
        <div class="rectangled-vertical subtitle-white">Rechthoekig</div>

        <div class="white-vertical"></div>
      </div>

      <mat-radio-button
        class="top-spaced"
        [value]="'vertical'"
        [checked]="position === 'vertical'"
        [disabled]="disabled"
        (change)="positionChange($event.value)"
      >
        Staand
      </mat-radio-button>
    </div>
  </mat-radio-group>

  <mat-radio-group
    *ngIf="index > 0"
    aria-label="Select an option"
    class="d-flex"
  >
    <mat-radio-button
      [value]="'square'"
      [checked]="position === 'square'"
      [disabled]="disabled"
      (change)="positionChange($event.value)"
    >
      Vierkant
    </mat-radio-button>

    <mat-radio-button
      class="left-space"
      [value]="'horizontal'"
      [checked]="position === 'horizontal'"
      [disabled]="disabled"
      (change)="positionChange($event.value)"
    >
      Liggend
    </mat-radio-button>

    <mat-radio-button
      class="left-space"
      [value]="'vertical'"
      [checked]="position === 'vertical'"
      [disabled]="disabled"
      (change)="positionChange($event.value)"
    >
      Staand
    </mat-radio-button>
  </mat-radio-group>

  <div class="d-flex">
    <selector
      #heightSelector
      [title]="'Hoogte'"
      [options]="heightOptions"
      [answer]="height"
      [disabled]="disabled"
      (answerChange)="setHeight($event)"
    ></selector>

    <selector
      #widthSelector
      class="spaced-left"
      [title]="'Breedte'"
      [options]="widthOptions"
      [answer]="width"
      [disabled]="disabled"
      (answerChange)="setWidth($event)"
    ></selector>
  </div>
</form>
